"use strict";

exports.__esModule = true;
var _LayoutEditor = require("./LayoutEditor");
Object.keys(_LayoutEditor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LayoutEditor[key]) return;
  exports[key] = _LayoutEditor[key];
});